import { v4 as uuid } from 'uuid';
import BlockComponentText from '../../../models/BlockComponentValues/BlockComponentText';

class BlockTableItemData {
  id: string;
  title: BlockComponentText;
  text: BlockComponentText;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockTableItemData {
  export function make(title: string, text: string): BlockTableItemData {
    return {
      id: uuid(),
      title: BlockComponentText.make(title),
      text: BlockComponentText.make(text),
    };
  }

  export function getDefault(
    title = 'Heading',
    text = 'Click here to enter the text you want to display. You can edit the text with options like "bold" and "font size".',
  ): BlockTableItemData {
    return make(
      `<p><strong>${title}</strong></p>`,
      `<p>${text}</p>`,
    );
  }
}

export default BlockTableItemData;
